export default [
    '54 54',
    '<rect x="0.3125" y="0.124023" width="53.7516" height="53.7516" rx="100%" fill="var(--light, #000000)"/>\n' +
    '<path d="M32.8,17.9h3.1l-6.7,7.7l7.9,10.5h-6.2L26,29.7l-5.6,6.4h-3.1l7.2-8.3l-7.6-10h6.4l4.4,5.8L32.8,17.9L32.8,17.9z M31.7,34.2\n' +
    '\th1.7l-11-14.6h-1.8C20.5,19.6,31.7,34.2,31.7,34.2z" fill="#fff"/>'
]